<template>
  <div id="app">
    <transition class="top-tips-father" name="fade"
                enter-active-class="fadeInDown"
                leave-active-class="fadeOutUp">
      <div class="top-tips animated" v-show="top_tips">{{ tipsContent }}</div>
    </transition>
    <div class="outer-tips" v-if="tips_toggle" @click="tips_toggle = false">
      <img src="./assets/jt.png" class="outer-tips-png"/>
      <div  class="tips">点击右上角用<span style="color: #FFCA72">「浏览器」</span>打开</div>
    </div>
    <music :style="{opacity: opacityMusic}" ref="music" class="music" />
    <div style="width: 0px;height: 0px;overflow: hidden">
      <img src="./assets/bg_polaroid@3x.png"/>
      <img src="./assets/person.png"/>
      <img src="./assets/resultPaperCapacitor.png"/>
      <img src="./assets/signaturePageCapacitor.png"/>
      <img src="./assets/resultPaperCapacitor.png">
      <img src="./assets/bg_paper2@3x.png"/>
      <img src="./assets/ChoiceGhost/bg.png"/>
      <img src="./assets/Playing/gg.png"/>
      <img src="./assets/Playing/mm.png"/>
      <img src="./assets/resultPaperCapacitor.png"/>
      <img src="./assets/resultPaperCapacitor2.png"/>
      <img src="./assets/fire2.jpg"/>
      <img src="./assets/fire.png"/>
    </div>
    <router-view/>
    <div class="bottom-my" v-if="!$root.cosSleep && $root.showDownLoad">
      <a target="view_window" href="https://www.heartide.com/statics/redirect?url=630" >
        <div class="bottom-img">
          <img  class='bottom-hehe' src="./assets/a.png"/>
        </div>
      </a>
      <a target="view_window" href="https://www.heartide.com/statics/redirect?url=630" >
        <p class="bottom-center">失眠睡不好  就用小睡眠</p>
      </a>
      <a class="dl"  target="view_window" href="https://www.heartide.com/statics/redirect?url=630" >
        <p class="bottom-dl">下&nbsp;&nbsp;载</p>
      </a>
    </div>
  </div>
</template>

<script>
  import music from './components/music.vue'
  export default {
    name: 'app',
    data () {
      return {
        showDown: false,
        opacityMusic: 1,
        top_tips: false,
        tipsContent: '',
        tips_toggle: false
      }
    },
    methods: {
      showTips (text) {
        if (this.top_tips) {
          return
        }
        this.tipsContent = text
        this.top_tips = true
        setTimeout(() => {
          this.top_tips = false
        }, 2000)
      }
    },
    components: {
      music
    }
  }
</script>

<style lang="scss" scoped>
  .outer-tips {
    font-size: px2html(14px);
    position: fixed;
    z-index:99999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
    .outer-tips-png {
      position: absolute;
      top:px2html(10px);
      right:px2html(22px);
      width: px2html(62px);
      height: px2html(47px);
    }
  }
  .tips{
    position:fixed;
    top: px2html(60px);
    right:px2html(10px);
    font-family:NotoSansCJKsc-Bold;
    font-size:px2html(18px);
    font-weight:bold;

    color:#fff;
    padding:px2html(8px);
    border-radius:px2html(10px);
    padding-left:px2html(15px);
    padding-right:px2html(15px);
    z-index:99999;
    //width:px2html(375px);
  }
</style>

<style lang="scss">

  .bottom-my {
    z-index: 2;
    height:px2html(40px);
    //overflow:hidden;
    background:#312736;
    width:px2html(375px);
    position:fixed;
    bottom:0%;
    left:0px;

    font-size:px2html(15px);
    color:#fff;
    .bottom-img{
      width:px2html(60px);
      position:relative;
      position:absolute;
      height:px2html(61px);
      left:px2html(-3px);
      top:px2html(-16px);
      .bottom-hehe{
        position:absolute;
        height:px2html(60px);
        width: px2html(60px);
        left:px2html(9px);
        top:px2html(-6px);
        z-index:999;
      }
    }

    .bottom-center{
      position:absolute;
      right:52%;
      top:50%;
      width:100%;
      transform: translateX(50%) translateY(-50%);
      color: #837D86;
      font-family: PingFangSC;
    }
    .bottom-dl{
      position:absolute;
      right:px2html(40px);
      top:50%;
      background-color: #5A525E;
      padding:px2html(10px);
      color: #fff;
      padding-top:px2html(1px);
      padding-bottom:px2html(1px);
      border-radius:px2html(18px);
      transform: translateX(50%) translateY(-50%);
    }
  }

  .top-tips-father {

  }
  .top-tips {
    background-color: rgba(87, 49, 30, 1);
    position: fixed;
    top: px2html(20px);
    // right: 50%;
    // transform: translateX(50%);
    z-index: 99;
    height: px2html(30px);
    width: px2html(130px);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    // background-color: rgba(0, 0, 0, 0.5);
    font-size: px2html(12px);
    border-radius: px2html(10px);
  }
  .music {
    position: absolute;
    right: px2html(5px);
    top: px2html(5px);
    width: px2html(80px);
    z-index: 1;
    // background: red;
  }
  * {
    padding: 0;
    margin: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color:transparent;
  }
  a,a:link,a:visited,a:hover,a:active{
    text-decoration: none;
    color:inherit;
  }
  @font-face {
    font-family: 'happy';
    src: url("./assets/happy.ttf");
  }
  .body {
    background-color: #fff;
  }
#app {
  background: url("./assets/NextVersions/background.png");
  background-size: 100% auto;
  background-repeat: repeat;
  background-color: #23172c;
  font-family: 'happy';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  justify-content: center;
  // align-items: center;
  min-height: 100vh;
  overflow: hidden;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}


</style>
